import { ReactElement } from 'react';
import { observer } from 'mobx-react';
import { QuizBlacklistSection } from '../../../components/domain/administration/quiz-blacklist/QuizBlacklistSection';

export const KvizBlacklist = observer((): ReactElement => {
  return <QuizBlacklistSection />;
});
